import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { switchMap } from 'rxjs/operators';
import { BaseService } from '../../shared/Services/BaseService';
@Component({
  selector: 'delete-confirmation',
  templateUrl: './delete-confirmation.component.html',
  styleUrls: ['./delete-confirmation.component.scss']
})
export class DeleteConfirmationComponent implements OnInit {

  id :number ;
  service: any;
  url :string;
  constructor(
    private route : Router,
    private diagRef: NbDialogRef<DeleteConfirmationComponent>,
    private toast: NbToastrService
  ) {}

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diagRef.close('false');
     });
  }

  delete() {
    this.service.delete(this.id).subscribe((res) => {
      this.toast.show('تم الحذف بنجاح', '', { status: 'success', duration: 4000 });
      this.diagRef.close('true');
        this.route.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.route.navigateByUrl(this.url);
    });
    });
       
  }
  close() {
    this.diagRef.close();
  }

}
